import React from 'react'
import { Spin, } from 'antd'

import './Loading.scss'

const Loading = () => (
  <div className="loading-container">
    <Spin size="large" />
  </div>
)

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.jsx